import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { readCookie } from '@/tools/tools';
import Im from '@/components/im/im.vue';
import { State } from 'vuex-class';
import YSF from '@neysf/qiyu-web-sdk';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isbackTop = false;
    _this.showIm = false; // 是否显示IM
    _this.picker = '';
    _this.obj = {};
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "isCustomerVisible",
    get: function get() {
      if (this.isConsumables) {
        return false;
      }
      if (this.showCustomer !== undefined) {
        return this.showCustomer;
      }
      return this.hasShopping;
    }
  }, {
    key: "created",
    value: function created() {
      window.addEventListener('scroll', this.handleScroll, true);
      if (this.$route.query.to === 'QtWebEngine') {
        this.openCustomer();
      }
    }
  }, {
    key: "setScrollDom",
    value: function setScrollDom(value) {
      this.obj = value;
    }
  }, {
    key: "closeIm",
    value: function closeIm() {
      this.showIm = false;
    }
  }, {
    key: "passpicker",
    value: function passpicker(picker) {
      this.picker = picker;
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
    // 格式化日期
  }, {
    key: "formatDate",
    value: function formatDate(timestamp) {
      if (!timestamp) return '';
      var date = new Date(timestamp);
      return "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, '0'), "-").concat(String(date.getDate()).padStart(2, '0'), " ").concat(String(date.getHours()).padStart(2, '0'), ":").concat(String(date.getMinutes()).padStart(2, '0'), ":").concat(String(date.getSeconds()).padStart(2, '0'));
    }
  }, {
    key: "openBrowser",
    value: function openBrowser() {
      var ua = navigator.userAgent;
      var url = window.location.href;
      var anchor = readCookie('anchor');
      if (ua.includes('QtWebEngine')) {
        var qtUrl;
        if (url.includes('token')) {
          qtUrl = "".concat(url, "&to=QtWebEngine");
        } else {
          var src = anchor && anchor.src ? anchor.src : 2;
          qtUrl = "".concat(url, "&src=").concat(src, "&model=").concat(anchor.model, "&version=").concat(anchor.version) + "&equipMeid=".concat(anchor.equipMeid, "&equipVersion=").concat(anchor.equipVersion, "&language=0") + "&equip=".concat(anchor.equip, "&appChannel=").concat(anchor.appChannel, "&macCode=").concat(anchor.macCode) + "&token=".concat(anchor.accessToken, "&to=QtWebEngine");
        }
        this.webTransport.openHyperlink(JSON.stringify({
          url: qtUrl,
          title: '商城',
          inside: 0,
          mall: 0,
          id: 0
        }));
      } else {
        this.openCustomer();
      }
    }
  }, {
    key: "memberLevelLabel",
    value: function memberLevelLabel(level) {
      if (level === 1) {
        return '黄金会员';
      }
      if (level === 2) {
        return '铂金会员';
      }
      if (level === 3) {
        return '黑卡会员';
      }
      return '';
    }
  }, {
    key: "openCustomer",
    value: function openCustomer() {
      var _this2 = this;
      var $that = this;
      if (readCookie('accessToken')) {
        YSF.init('f63f37230285130a3eb89565948cdcef', {
          sdkTemplateId: 8128534
        }).then(function (ysf) {
          // 重置商品消息
          ysf.clearProduct();
          ysf('config', {
            uid: _this2.userInfo.userinfolist.id,
            name: _this2.userInfo.userinfolist.nickName,
            mobile: _this2.userInfo.userinfolist.phone,
            data: JSON.stringify([{
              index: 0,
              key: 'Source_channels',
              label: '来源渠道',
              value: '驰腾商城PC端'
            }, {
              index: 1,
              key: 'grade_membership',
              label: '会员等级',
              value: _this2.memberLevelLabel(_this2.userInfo.userinfolist.level)
            }, {
              index: 2,
              key: 'reg_date',
              label: '注册日期',
              value: _this2.formatDate(_this2.userInfo.userinfolist.createTime)
            }, {
              index: 3,
              key: 'last_login',
              label: '上次登录时间',
              value: _this2.formatDate(_this2.userInfo.userinfolist.updateTime)
            }, {
              index: 4,
              key: 'avatar',
              label: '头像',
              value: _this2.userInfo.userinfolist.headImgUrl ? _this2.userInfo.userinfolist.headImgUrl : ''
            }, {
              index: 5,
              key: 'email',
              hidden: true,
              value: ''
            }, {
              index: 6,
              key: 'integral',
              label: '会员积分',
              value: $that.userInfo.userinfolist.integral > 0 ? $that.userInfo.userinfolist.integral : '0'
            }]),
            success: function success() {
              // 成功回调,判断是web打开还是从PC端打开才触发发送商品
              var obj = JSON.parse(sessionStorage.getItem('detailsList') || '{}');
              if ($that.$route.path === '/details') {
                if ($that.$route.query.to === 'QtWebEngine') {
                  var _$that$obj$listImageP;
                  ysf('product', {
                    sendByUser: 1,
                    actionText: '发送链接',
                    actionTextColor: '#000000',
                    show: 1,
                    title: $that.obj.productName,
                    desc: $that.obj.productShortDesc,
                    note: "\uFFE5".concat($that.obj.lowestPrice.split(',')[0]),
                    picture: ((_$that$obj$listImageP = $that.obj.listImagePath) === null || _$that$obj$listImageP === void 0 ? void 0 : _$that$obj$listImageP.cdnFilePathH5) || '',
                    url: "".concat(process.env.VUE_APP_BASE_API, "/details?id=").concat($that.$route.query.id, "&productPriceId=").concat($that.$route.query.productPriceId)
                  });
                } else {
                  var _obj$listImagePath;
                  ysf('product', {
                    sendByUser: 1,
                    actionText: '发送链接',
                    actionTextColor: '#000000',
                    show: 1,
                    title: obj.productName,
                    desc: obj.productShortDesc,
                    note: "\uFFE5".concat(obj.lowestPrice.split(',')[0]),
                    picture: ((_obj$listImagePath = obj.listImagePath) === null || _obj$listImagePath === void 0 ? void 0 : _obj$listImagePath.cdnFilePathH5) || '',
                    url: "".concat(process.env.VUE_APP_BASE_API, "/details?id=").concat(obj.id, "&productPriceId=").concat(obj.productPriceId)
                  });
                }
              }
            },
            error: function error() {
              // 错误回调
              // handle error
            }
          });
          // 打开客服
          ysf('open');
        }).catch(function () {
          // 七鱼初始化失败时静默处理
        });
      } else {
        this.$router.push('/login?redirect=/grade');
      }
      // 原IM对接逻辑
      // let tempUrl = this.$route.fullPath;
      // if (!readCookie('accessToken')) {
      //   if (tempUrl.indexOf('?') !== -1) {
      //     tempUrl += '&openCustomer=1';
      //   } else {
      //     tempUrl += '?openCustomer=1';
      //   }
      //   writeCookie('openCustomer', '1');
      //   this.$router.push({ name: 'login', query: { redirect: tempUrl } });
      // } else {
      //   this.showIm = true;
      //   setTimeout(() => {
      //     this.picker.initData();
      //   }, 0);
      // }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var sT = document.documentElement.scrollTop || document.body.scrollTop; // 滚动距离
      // const headerHeight = (this as any).$refs.header.offsetHeight;
      this.isbackTop = sT >= 100;
    }
  }, {
    key: "goTop",
    value: function goTop() {
      // 回到顶部
      window.scrollTo(0, 0);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], default_1.prototype, "isConsumables", void 0);
__decorate([State('user')], default_1.prototype, "userInfo", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "hasShopping", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "showCart", void 0);
__decorate([Prop({
  default: undefined
})], default_1.prototype, "showCustomer", void 0);
__decorate([State('card')], default_1.prototype, "cardstate", void 0);
__decorate([State('home')], default_1.prototype, "homestate", void 0);
default_1 = __decorate([Component({
  name: 'BackTop',
  components: {
    Im: Im
  }
})], default_1);
export default default_1;